// extracted by mini-css-extract-plugin
export var alertIcon = "_th-0";